var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelectBoxFill = function SvgSelectBoxFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.2 2.6h9.6a.6.6 0 0 1 .6.6v9.6a.6.6 0 0 1-.6.6H3.2a.6.6 0 0 1-.6-.6V3.2a.6.6 0 0 1 .6-.6m4.202 7.8 4.242-4.243-.849-.848-3.393 3.394-1.698-1.698-.848.849z"
  })));
};
export default SvgSelectBoxFill;